module.exports = __webpack_public_path__ + "static/img/button.aa38e2a1.png";